import { FC, ReactElement } from 'react'

export interface Message {
  type: string
  title: string
  body: string
  actions?: {
    onOk: () => void
  }
}

interface NotificationProps {
  message: Message
}

export const Notification: FC<NotificationProps> = ({ message }): ReactElement => (
  <div className="popup-notification">
    <div className="m-auto">
      <div className="bg-white rounded-lg border-gray-300 border p-3 shadow-lg">
        <div className="flex flex-row">
          <div className="px-2">
            {message.type === 'fail' ? (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="#f56565"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="#44C997"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            )}
          </div>
          <div className="ml-2 mr-6">
            <div
              className="font-semibold"
              style={{ color: message.type === 'fail' ? '#f56565' : '' }}
            >
              {message?.title}
            </div>
            <div className="block text-gray-500">{message?.body}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
